import { reactive, ref, computed } from 'vue';

const STORAGE_KEY = 'muala-admin-api-token';
const ENV_TOKEN = process.env.VUE_APP_ADMIN_API_TOKEN || process.env.VUE_APP_ADMIN_API_TOKEN_FALLBACK || '';

const state = reactive({
  token: '',
  source: 'none',
});

const authErrorMessage = ref('');

const safeWindow = () => (typeof window !== 'undefined' ? window : undefined);

const readFromStorage = () => {
  const win = safeWindow();
  if (!win) {
    state.token = ENV_TOKEN || '';
    state.source = ENV_TOKEN ? 'env' : 'none';
    return;
  }

  const { sessionStorage, localStorage } = win;

  const sessionToken = sessionStorage.getItem(STORAGE_KEY);
  if (sessionToken) {
    state.token = sessionToken;
    state.source = 'session';
    return;
  }

  const persistentToken = localStorage.getItem(STORAGE_KEY);
  if (persistentToken) {
    state.token = persistentToken;
    state.source = 'local';
    return;
  }

  if (ENV_TOKEN) {
    state.token = ENV_TOKEN;
    state.source = 'env';
    return;
  }

  state.token = '';
  state.source = 'none';
};

export const initAdminApiAuth = () => {
  readFromStorage();
};

export const getAdminApiToken = () => state.token || '';

export const getAdminApiTokenSource = () => state.source;

const clearStorage = () => {
  const win = safeWindow();
  if (!win) {
    return;
  }

  win.sessionStorage.removeItem(STORAGE_KEY);
  win.localStorage.removeItem(STORAGE_KEY);
};

export const setAdminApiToken = (token, { persist = 'session' } = {}) => {
  const win = safeWindow();

  clearStorage();

  if (token) {
    if (win) {
      const target =
        persist === 'local' ? win.localStorage : win.sessionStorage;
      target.setItem(STORAGE_KEY, token);
    }
    state.token = token;
    state.source = persist === 'local' ? 'local' : 'session';
    authErrorMessage.value = '';
    return;
  }

  if (ENV_TOKEN) {
    state.token = ENV_TOKEN;
    state.source = 'env';
  } else {
    state.token = '';
    state.source = 'none';
  }
};

export const clearAdminApiToken = () => {
  clearStorage();
  if (ENV_TOKEN) {
    state.token = ENV_TOKEN;
    state.source = 'env';
  } else {
    state.token = '';
    state.source = 'none';
  }
};

export const useAdminApiAuth = () => {
  const tokenSource = computed(() => state.source);
  const hasToken = computed(() => Boolean(getAdminApiToken()));

  const authError = computed(() => authErrorMessage.value);

  const dismissAuthError = () => {
    authErrorMessage.value = '';
  };

  return {
    authError,
    dismissAuthError,
    tokenSource,
    hasToken,
  };
};

export const setAuthErrorMessage = (message) => {
  authErrorMessage.value = message || '';
};





